import { ALL_EMPLOYESS_API } from "../../../Utilities/APIs/APIs";
import Employees from "../AuthScreens/Employees/Employees";

export default function Producers() {
    return (
        <Employees
            headingTitle={'Producers'}
            api={`${ALL_EMPLOYESS_API}?level=producer`}
        />
    )
}
